import { ref, reactive, onMounted, computed, watch } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/HeaderDashboard.vue';
import Swal from 'sweetalert2';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});
import { hasPermission } from '@/store/userStore';
import { ProveedorService } from '@/services/ProveedorService';
import { MaestrosService } from '@/services/MaestrosService';
import { PlusIcon, EditIcon, TrashIcon, SearchIcon, ChevronLeftIcon, ChevronRightIcon, XIcon, UserIcon, PhoneIcon, MailIcon, TruckIcon, PowerIcon, Loader2Icon, CheckCircle2Icon, CreditCardIcon, CoinsIcon, ArrowRightLeftIcon, WalletIcon, SmartphoneIcon, BanknoteIcon } from 'lucide-vue-next';
import { InstrumentoPagoService } from '@/services/InstrumentoPagoService';
export default {
    name: 'Proveedores',
    components: { Sidebar, Header, PlusIcon, EditIcon, TrashIcon, SearchIcon, ChevronLeftIcon, ChevronRightIcon, XIcon, UserIcon, PhoneIcon, MailIcon, TruckIcon, PowerIcon, Loader2Icon, CheckCircle2Icon, CreditCardIcon, CoinsIcon, ArrowRightLeftIcon, WalletIcon, SmartphoneIcon, BanknoteIcon },
    setup() {
        const proveedores = ref([]);
        const isLoading = ref(false);
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        const searchQuery = ref('');
        const selectedLetter = ref(null);
        const currentPage = ref(1);
        const itemsPerPage = ref(8);
        const isModalOpen = ref(false);
        const isEditing = ref(false);
        const maestros = reactive({
            estados: [],
            municipios: [],
            parroquias: [],
            tiposDocumento: [],
            origenes: [],
            tipos: [],
            monedas: [],
            instrumentos: []
        });
        const isInstrumentsModalOpen = ref(false);
        const selectedProveedor = ref(null);
        const providerInstruments = ref([]);
        const isAddingInstrument = ref(false);
        const instrumentForm = ref({
            id: null,
            nombre: '',
            metodo: '',
            monedaId: 1,
            banco: '',
            titular: '',
            numeroIdentificacion: '',
            numeroCuenta: '',
            tipoCuenta: 'Corriente',
            email: '',
            telefono: '',
            modeloEquipo: '',
            numeroTerminal: '',
            numeroSIM: '',
            direccionID: '',
            nombreCaja: ''
        });
        const metodosDisponibles = [
            'EFECTIVO', 'TRANSFERENCIA', 'ZELLE', 'PAGOMOVIL', 'BIOPAGO',
            'WALLET', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'
        ];
        const resetInstrumentForm = () => {
            instrumentForm.value = {
                id: null,
                nombre: '',
                metodo: '', // Vacío para forzar selección y despliegue dinámico
                monedaId: 1,
                banco: '',
                titular: '',
                numeroIdentificacion: '',
                numeroCuenta: '',
                tipoCuenta: 'Corriente',
                direccionID: '',
                nombreCaja: '',
                modeloEquipo: '',
                numeroTerminal: '',
                numeroSIM: '',
                email: '',
                telefono: ''
            };
        };
        const addInstrument = () => {
            resetInstrumentForm();
            isAddingInstrument.value = true;
        };
        const editInstrument = (instr) => {
            instrumentForm.value = {
                id: instr.instrumentoPagoProveedorId,
                ...instr
            };
            isAddingInstrument.value = true;
        };
        const showInstrumentField = (field) => {
            const method = instrumentForm.value.metodo?.toUpperCase();
            if (!method)
                return false;
            switch (field) {
                case 'banco':
                    return ['TRANSFERENCIA', 'ZELLE', 'PAGOMOVIL', 'BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'].includes(method);
                case 'titular':
                    return method !== 'EFECTIVO';
                case 'numeroIdentificacion':
                    return ['TRANSFERENCIA', 'PAGOMOVIL', 'BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL', 'DEPOSITO'].includes(method);
                case 'numeroCuenta':
                    return ['TRANSFERENCIA', 'DEPOSITO'].includes(method);
                case 'tipoCuenta':
                    return ['TRANSFERENCIA', 'DEPOSITO'].includes(method);
                case 'email':
                    return ['ZELLE', 'WALLET'].includes(method);
                case 'telefono':
                    return ['PAGOMOVIL', 'BIOPAGO', 'DATAFONO_FISICO', 'WALLET'].includes(method);
                case 'modeloEquipo':
                    return ['BIOPAGO', 'DATAFONO_FISICO', 'DATAFONO_VIRTUAL'].includes(method);
                case 'numeroTerminal':
                    return ['DATAFONO_FISICO', 'DATAFONO_VIRTUAL'].includes(method);
                case 'numeroSIM':
                    return method === 'DATAFONO_FISICO';
                case 'direccionID':
                    return method === 'WALLET';
                case 'nombreCaja':
                    return method === 'EFECTIVO';
                default:
                    return false;
            }
        };
        const initialFormState = () => ({
            proveedorId: 0,
            tipoDocumentoId: 0,
            documentoNumero: '',
            nombreRazonSocial: '',
            nombreFirmaPersonal: '',
            direccionFiscal: '',
            estadoId: 0,
            municipioId: 0,
            parroquiaId: 0,
            sector: '',
            ciudad: '',
            representante: '',
            telLocal1: '',
            telCelular1: '',
            email: '',
            origenProveedorId: 0,
            tipoProveedorId: 0,
            tiempoEntregaDias: 7,
            vendedorNombre: '',
            vendedorTipoDocumentoId: 0,
            vendedorDocumentoNumero: '',
            vendedorTelefono: '',
            vendedorTelefonoPrefix: '+58',
            vendedorTelefonoNumber: '',
            monedaIntercambioId: 1,
            usuarioRegistro: 'Admin',
            active: true,
            telCelular1Prefix: '+58',
            telCelular1Number: '',
            telLocal1Prefix: '+58',
            telLocal1Number: ''
        });
        const formErrors = ref({
            tipoDocumentoId: false,
            origenProveedorId: false,
            tipoProveedorId: false,
            estadoId: false,
            municipioId: false,
            parroquiaId: false
        });
        const form = ref(initialFormState());
        const getPrefix = (id) => {
            const doc = maestros.tiposDocumento.find((d) => d.tipoDocumentoId === id);
            if (!doc)
                return '';
            const desc = doc.descripcion.toUpperCase();
            if (desc.includes('VENEZOLANO'))
                return 'V';
            if (desc.includes('EXTRANJERO'))
                return 'E';
            if (desc.includes('JURIDICO'))
                return 'J';
            if (desc.includes('RIF'))
                return 'RIF';
            if (desc.includes('PASAPORTE'))
                return 'P';
            const first = desc[0];
            if (['V', 'E', 'J', 'G', 'P'].includes(first))
                return first;
            return '';
        };
        const cleanDocumento = () => {
            const prefix = getPrefix(form.value.tipoDocumentoId);
            if (!prefix)
                return;
            const numbers = form.value.documentoNumero.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            form.value.documentoNumero = `${prefix}-${numbers}`;
        };
        const updateDocumentoPrefix = () => {
            const prefix = getPrefix(form.value.tipoDocumentoId);
            if (!prefix)
                return;
            const numbers = form.value.documentoNumero.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            form.value.documentoNumero = `${prefix}-${numbers}`;
        };
        const cleanDocumentoVendedor = () => {
            const prefix = getPrefix(form.value.vendedorTipoDocumentoId);
            if (!prefix)
                return;
            const numbers = form.value.vendedorDocumentoNumero.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            form.value.vendedorDocumentoNumero = `${prefix}-${numbers}`;
        };
        const updatePrefixVendedor = () => {
            const prefix = getPrefix(form.value.vendedorTipoDocumentoId);
            if (!prefix)
                return;
            const numbers = form.value.vendedorDocumentoNumero.split('-').pop()?.replace(/[^0-9]/g, '') || '';
            form.value.vendedorDocumentoNumero = `${prefix}-${numbers}`;
        };
        const getDocumentoFormateado = (item) => {
            const prefix = getPrefix(item.tipoDocumentoId);
            const numbers = item.documentoNumero?.replace(/[^0-9]/g, '') || '';
            return `${prefix}-${numbers}`;
        };
        const totalCount = ref(0);
        const totalPages = ref(1);
        const loadData = async () => {
            isLoading.value = true;
            try {
                const [resProv, resEst, resDoc, resOrig, resTipos, resMonedas, resInstr] = await Promise.all([
                    ProveedorService.getAll(currentPage.value, searchQuery.value, selectedLetter.value || ''),
                    MaestrosService.getEstados(),
                    MaestrosService.getTiposDocumento(),
                    ProveedorService.getOrigenes(),
                    ProveedorService.getTipos(),
                    InstrumentoPagoService.getMonedas(),
                    InstrumentoPagoService.getInstrumentos()
                ]);
                proveedores.value = resProv.datos.items || [];
                totalCount.value = resProv.datos.totalCount || 0;
                totalPages.value = resProv.datos.totalPages || 1;
                maestros.estados = resEst.datos || [];
                maestros.tiposDocumento = resDoc.datos || [];
                maestros.origenes = resOrig.datos || [];
                maestros.tipos = resTipos.datos || [];
                maestros.monedas = resMonedas.datos || [];
                maestros.instrumentos = resInstr.datos || [];
            }
            finally {
                isLoading.value = false;
            }
        };
        let searchTimeout;
        watch([currentPage, selectedLetter, searchQuery], (newValues, oldValues) => {
            // Check if searchQuery is what changed (it's at index 2)
            if (newValues[2] !== oldValues[2]) {
                isLoading.value = true;
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    currentPage.value = 1;
                    loadData();
                }, 500);
            }
            else {
                loadData();
            }
        });
        const onEstadoChange = async () => {
            form.value.municipioId = 0;
            form.value.parroquiaId = 0;
            const res = await MaestrosService.getMunicipiosByEstado(form.value.estadoId);
            maestros.municipios = res.datos || [];
        };
        const onMunicipioChange = async () => {
            form.value.parroquiaId = 0;
            const res = await MaestrosService.getParroquiasByMunicipio(form.value.municipioId);
            maestros.parroquias = res.datos || [];
        };
        const processedProveedores = computed(() => {
            return proveedores.value;
        });
        const splitPhone = (full) => {
            if (!full)
                return { prefix: '+58', number: '' };
            if (full.startsWith('+')) {
                const prefix = full.startsWith('+1') ? '+1' : '+58';
                return { prefix, number: full.replace(prefix, '') };
            }
            return { prefix: '+58', number: full };
        };
        const openModal = async (item = null) => {
            formErrors.value = {
                tipoDocumentoId: false,
                origenProveedorId: false,
                tipoProveedorId: false,
                estadoId: false,
                municipioId: false,
                parroquiaId: false
            };
            isEditing.value = !!item;
            if (item) {
                form.value = {
                    ...item
                };
                const cel = splitPhone(item.telCelular1);
                form.value.telCelular1Prefix = cel.prefix;
                form.value.telCelular1Number = cel.number;
                const loc = splitPhone(item.telLocal1);
                form.value.telLocal1Prefix = loc.prefix;
                form.value.telLocal1Number = loc.number;
                const ven = splitPhone(item.vendedorTelefono);
                form.value.vendedorTelefonoPrefix = ven.prefix;
                form.value.vendedorTelefonoNumber = ven.number;
                const [m, p] = await Promise.all([
                    MaestrosService.getMunicipiosByEstado(item.estadoId),
                    MaestrosService.getParroquiasByMunicipio(item.municipioId)
                ]);
                maestros.municipios = m.datos || [];
                maestros.parroquias = p.datos || [];
            }
            else {
                form.value = initialFormState();
            }
            isModalOpen.value = true;
        };
        const saveProveedor = async () => {
            formErrors.value.tipoDocumentoId = form.value.tipoDocumentoId === 0;
            formErrors.value.origenProveedorId = form.value.origenProveedorId === 0;
            formErrors.value.tipoProveedorId = form.value.tipoProveedorId === 0;
            formErrors.value.estadoId = form.value.estadoId === 0;
            formErrors.value.municipioId = form.value.municipioId === 0;
            formErrors.value.parroquiaId = form.value.parroquiaId === 0;
            if (Object.values(formErrors.value).some(v => v)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos incompletos',
                    text: 'Debe seleccionar una opción en los campos marcados en rojo.',
                    confirmButtonColor: '#3b82f6'
                });
                return;
            }
            try {
                // Combinar teléfonos antes de enviar
                form.value.telCelular1 = `${form.value.telCelular1Prefix}${form.value.telCelular1Number.trim()}`;
                form.value.telLocal1 = `${form.value.telLocal1Prefix}${form.value.telLocal1Number.trim()}`;
                form.value.vendedorTelefono = `${form.value.vendedorTelefonoPrefix}${form.value.vendedorTelefonoNumber.trim()}`;
                const res = isEditing.value
                    ? await ProveedorService.updateProveedor(form.value.proveedorId, form.value)
                    : await ProveedorService.addProveedor(form.value);
                if (res.exito) {
                    Swal.fire('Éxito', 'Operación completada', 'success');
                    isModalOpen.value = false;
                    loadData();
                }
            }
            catch (e) {
                Swal.fire('Error', 'No se pudo guardar', 'error');
            }
        };
        const toggleActive = async (item) => {
            const result = await Swal.fire({
                title: '¿Cambiar estado?',
                text: `¿Estás seguro de que deseas ${item.active ? 'desactivar' : 'activar'} al proveedor "${item.nombreRazonSocial}"?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, cambiar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
            });
            if (!result.isConfirmed)
                return;
            try {
                const res = await ProveedorService.toggleActivo(item.proveedorId);
                if (res.exito) {
                    item.active = !item.active;
                    Swal.fire({
                        title: item.active ? 'Habilitado' : 'Deshabilitado',
                        text: `El proveedor ahora está ${item.active ? 'activo' : 'inactivo'}.`,
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
            catch (e) {
                Swal.fire('Error', 'No se pudo cambiar el estado', 'error');
            }
        };
        const confirmDelete = async (id) => {
            const res = await Swal.fire({
                title: '¿Desea eliminar este proveedor?',
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });
            if (res.isConfirmed) {
                try {
                    const response = await ProveedorService.deleteProveedor(id);
                    if (response.exito) {
                        Swal.fire({ title: '¡Eliminado!', text: 'El proveedor ha sido borrado.', icon: 'success', timer: 1500, showConfirmButton: false });
                        loadData();
                    }
                    else {
                        Swal.fire('Error', response.errores || 'No se pudo eliminar', 'error');
                    }
                }
                catch (error) {
                    Swal.fire('Error', 'Fallo de comunicación', 'error');
                }
            }
        };
        onMounted(loadData);
        return {
            hasPermission,
            proveedores, isLoading, alphabet, searchQuery, selectedLetter, currentPage, maestros, form, formErrors, isModalOpen, isEditing,
            cleanDocumento, updateDocumentoPrefix, getDocumentoFormateado,
            cleanDocumentoVendedor, updatePrefixVendedor,
            totalCount,
            totalPages,
            paginatedProveedores: computed(() => processedProveedores.value),
            filterByLetter: (l) => { selectedLetter.value = l; currentPage.value = 1; },
            resetFilter: () => { selectedLetter.value = null; searchQuery.value = ''; currentPage.value = 1; },
            prevPage: () => { if (currentPage.value > 1)
                currentPage.value--; },
            nextPage: () => { if (currentPage.value < totalPages.value)
                currentPage.value++; },
            openModal, closeModal: () => isModalOpen.value = false, saveProveedor, toggleActive,
            onEstadoChange, onMunicipioChange,
            placeholderDoc: computed(() => {
                const prefix = getPrefix(form.value.tipoDocumentoId);
                return prefix ? `Ej: ${prefix}-12345678` : 'Seleccione tipo primero...';
            }),
            placeholderDocVendedor: computed(() => {
                const prefix = getPrefix(form.value.vendedorTipoDocumentoId);
                return prefix ? `Ej: ${prefix}-12345678` : 'Seleccione tipo primero...';
            }),
            confirmDelete,
            isInstrumentsModalOpen,
            selectedProveedor,
            providerInstruments,
            isAddingInstrument,
            instrumentForm,
            metodosDisponibles,
            showInstrumentField,
            openInstrumentsModal: async (item) => {
                selectedProveedor.value = item;
                isInstrumentsModalOpen.value = true;
                isAddingInstrument.value = false;
                await loadProviderInstruments();
            },
            openAddInstrument: () => {
                resetInstrumentForm();
                // Pre-llenar con datos del proveedor si es posible
                instrumentForm.value.titular = selectedProveedor.value.nombreRazonSocial;
                instrumentForm.value.numeroIdentificacion = selectedProveedor.value.documentoNumero;
                isAddingInstrument.value = true;
            },
            editInstrument: (instr) => {
                instrumentForm.value = {
                    id: instr.instrumentoPagoProveedorId,
                    ...instr
                };
                isAddingInstrument.value = true;
            },
            saveInstrument: async () => {
                // 1. Validaciones de base
                if (!instrumentForm.value.nombre) {
                    Swal.fire('Error', 'Debe indicar un nombre identificador.', 'warning');
                    return;
                }
                if (!instrumentForm.value.metodo) {
                    Swal.fire('Error', 'Debe seleccionar un método de pago.', 'warning');
                    return;
                }
                if (!instrumentForm.value.monedaId) {
                    Swal.fire('Error', 'Debe seleccionar una moneda.', 'warning');
                    return;
                }
                // 2. Validaciones dinámicas según lo que se muestra en UI
                const f = instrumentForm.value;
                let missing = [];
                if (showInstrumentField('banco') && !f.banco)
                    missing.push('Banco');
                if (showInstrumentField('titular') && !f.titular)
                    missing.push('Titular');
                if (showInstrumentField('numeroCuenta') && !f.numeroCuenta)
                    missing.push('N° Cuenta / Identificador');
                if (showInstrumentField('numeroIdentificacion') && !f.numeroIdentificacion)
                    missing.push('RIF / Cédula');
                if (showInstrumentField('email') && !f.email)
                    missing.push('Email');
                if (showInstrumentField('telefono') && !f.telefono)
                    missing.push('Teléfono');
                if (showInstrumentField('direccionID') && !f.direccionID)
                    missing.push('Wallet ID');
                if (showInstrumentField('nombreCaja') && !f.nombreCaja)
                    missing.push('ID Caja');
                if (showInstrumentField('modeloEquipo') && !f.modeloEquipo)
                    missing.push('Modelo Equipo');
                if (showInstrumentField('numeroTerminal') && !f.numeroTerminal)
                    missing.push('N° Terminal');
                if (showInstrumentField('numeroSIM') && !f.numeroSIM)
                    missing.push('SIM Card');
                if (missing.length > 0) {
                    Swal.fire('Campos Requeridos', `Faltan los siguientes datos: ${missing.join(', ')}`, 'warning');
                    return;
                }
                const data = {
                    ...instrumentForm.value,
                    instrumentoPagoProveedorId: instrumentForm.value.id || 0,
                    proveedorId: selectedProveedor.value.proveedorId
                };
                try {
                    const res = instrumentForm.value.id
                        ? await ProveedorService.updateInstrumento(instrumentForm.value.id, data)
                        : await ProveedorService.addInstrumento(data);
                    if (res.exito) {
                        Swal.fire('Éxito', 'Guardado correctamente', 'success');
                        isAddingInstrument.value = false;
                        loadProviderInstruments();
                    }
                }
                catch (e) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                }
            },
            deleteInstrument: async (id) => {
                const res = await Swal.fire({
                    title: '¿Eliminar instrumento?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, eliminar'
                });
                if (res.isConfirmed) {
                    try {
                        const response = await ProveedorService.deleteInstrumento(id);
                        if (response.exito) {
                            Swal.fire('Eliminado', '', 'success');
                            loadProviderInstruments();
                        }
                    }
                    catch (e) {
                        Swal.fire('Error', 'No se pudo eliminar', 'error');
                    }
                }
            },
            toggleInstrumentActive: async (item) => {
                const result = await Swal.fire({
                    title: '¿Cambiar estado?',
                    text: `¿Estás seguro de que deseas ${item.activo ? 'desactivar' : 'activar'} este método de pago?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, cambiar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#3b82f6',
                    cancelButtonColor: '#94a3b8',
                });
                if (!result.isConfirmed)
                    return;
                try {
                    const res = await ProveedorService.toggleActivoInstrumento(item.instrumentoPagoProveedorId);
                    if (res.exito) {
                        item.activo = !item.activo;
                        Toast.fire({
                            icon: 'success',
                            title: `Método de pago ${item.activo ? 'activado' : 'desactivado'}`
                        });
                    }
                }
                catch (e) {
                    Swal.fire('Error', 'No se pudo cambiar el estado', 'error');
                }
            }
        };
        async function loadProviderInstruments() {
            if (!selectedProveedor.value)
                return;
            try {
                const res = await ProveedorService.getInstrumentos(selectedProveedor.value.proveedorId);
                providerInstruments.value = res.datos || [];
            }
            catch (e) {
                console.error(e);
            }
        }
    }
};
